import Modal from "common/components/Modal";
import axios from "common/configs/axiosConfigs";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const LeadCard = ({ c, getLeads, leadId }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const companyId = JSON.parse(localStorage.getItem("user-auth"))?.company_id;
  const onCancelDelete = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const handleDeleteLead = async () => {
    try {
      const { data } = await axios.post("", { action: "deleteLead", companyId, leadId: c?.id });
      if (data.success) {
        toast.success(data?.msg);
        getLeads();
      } else {
        toast.error(data?.msg);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  return (
    <>
      <div className="card contact-card h-100">
        <div className="contact-header">
          <div className="contact-header-left">
            <h6>
              {c?.honorifics} {c?.firstName} {c?.lastName}
            </h6>
            <span className="text-muted">{c?.email || "-"}</span>
          </div>
          <div className="ms-auto align-items-center d-flex contact-actions col">
            <a href={`tel:${c?.phone}`} className="bg-success">
              <i className="bi bi-telephone"></i>
            </a>
            <a
              href={`mailto:${c?.email}`}
              className="bg-danger"
              style={{ ...(!c?.email && { opacity: 0.5, pointerEvents: "none" }) }}
            >
              <i className="bi bi-envelope"></i>
            </a>
            <div ref={dropdownRef}>
              <button
                type="button"
                className="p-0 ms-2"
                onClick={() => setIsDropdownOpen((p) => !p)}
              >
                <i className="bi bi-three-dots-vertical fs-20"></i>
              </button>
              <div className={`drop-box ${isDropdownOpen ? "" : "d-none"}`}>
                <Link to={`/lead-details/${c?.id}`}>
                  <i className="me-2 bi bi-eye"></i>View
                </Link>
                <button type="button">
                  <i className="me-2 bi bi-pencil-square"></i>Edit
                </button>
                <button type="button" onClick={() => setIsOpen(true)}>
                  <i className="me-2 bi bi-trash3"></i>Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <span className="label">Requirements</span>
        <div className="row property-features">
          <span className="bg-light">For {c?.sale_type}</span>
          <span className="bg-light">{c?.property_type_name}</span>
          <span className="bg-light">{c?.property_subtype_name}</span>
        </div>
        <hr />
        <span className="label">Lead Info</span>
        <div className="row gy-3">
          <div className=" col-4">
            <span className="text-muted">Score</span>
            <p>{c?.score}%</p>
          </div>
          <div className=" col-4">
            <span className="text-muted">Source</span>
            <p>{c?.source}</p>
          </div>
          <div className=" col-4">
            <span className="text-muted">Assignee</span>
            <p>{c?.assignee}</p>
          </div>
        </div>
      </div>
      <Modal {...{ isOpen, onClose: onCancelDelete, title: "Confirmation", size: "sm", leadId }}>
        <>
          <p>Are you sure you want to delete?</p>
          <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
            <button type="button" className="btn btn-light me-2" onClick={onCancelDelete}>
              No
            </button>
            <button type="submit" className="btn btn-primary" onClick={handleDeleteLead}>
              Yes
            </button>
          </div>
        </>
      </Modal>
    </>
  );
};

export default LeadCard;
